<p-card>
  <ng-template pTemplate="title">
    <div class="components-inventory-header">
      <span>Components Inventory</span>
      <span class="components-inventory-total">Total: {{ componentsInventoryTotal | number:'1.0-0' }}</span>
    </div>
  </ng-template>
  <p-table [value]="componentInventoryItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th *ngIf="isChepComponents">Repair Type<span class="required">*</span></th>
        <th>Product<span class="required">*</span></th>
        <th># of Skids<span class="required">*</span></th>
        <th>X</th>
        <th>Quantity per Skid<span class="required">*</span></th>
        <th>Pieces<span class="required">*</span></th>
        <th>Total</th>
        <th *ngIf="isChepComponents">Allocated <br> From PLUS<span class="required">*</span></th>
        <th>Teardown <br> Reclaimed<span class="required">*</span></th>
        <th>Sorters <br> Reclaimed<span class="required">*</span></th>
        <th>Delete</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr [formGroup]="rowData">
        <td>
          <div class="centered">
            {{rowData.controls.displayOrder.value}}
          </div>
        </td>
        <td *ngIf="isChepComponents">
          <p-dropdown
            [options]="bayTypesSelect"
            formControlName="bayType"
            appendTo="body"
            name="product"
            [required]
            [editable]="false">
          </p-dropdown>
        </td>
        <td>
          <p-dropdown
            [options]="products"
            formControlName="productId"
            appendTo="body"
            name="product"
            [required]
            [filter]="true"
            [editable]="false"
            [resetFilterOnHide]="true">
          </p-dropdown>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="dim1x"
            style="width:100%"
            name="dim1x"
            required
            lib-numeric>
        </td>
        <td class="tdX">
          <div class="centered">
            X
          </div>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="dim1y"
            style="width:100%"
            name="dim1y"
            required
            lib-numeric>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="pieces1"
            style="width:100%"
            name="pieces1"
            required
            lib-numeric>
        </td>
        <td class="tdX">
          <div class="centered">
            {{rowData.totalInventory}}
          </div>
        </td>
        <td *ngIf="isChepComponents">
          <input pInputText type="number"
            formControlName="allocatedFromPlus"
            style="width:100%"
            name="allocatedFromPlus"
            required
            lib-numeric>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="reclaimedFromTdwn"
            style="width:100%"
            name="reclaimedFromTdwn"
            required
            lib-numeric>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="reclaimedFromSort"
            style="width:100%"
            name="reclaimedFromSort"
            required
            lib-numeric>
        </td>
        <td>
          <confirmation-button
            [iconsOnly]="true"
            actionIcon="pi pi-times"
            actionText="Delete"
            confirmIcon="pi pi-times"
            confirmText="Delete"
            cancelIcon="pi pi-minus-circle"
            cancelText="Cancel"
            [disabled]="rowData.disabled"
            (actionConfirmed)="deleteInventoryRow(rowData)">
          </confirmation-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="isChepComponents ? 10 : 8" class="centered">
          No data available
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr [formGroup]="componentInventoryForm">
        <td class="centered">
          {{formDisplayOrder}}
        </td>
        <td *ngIf="isChepComponents">
          <p-dropdown [options]="bayTypesSelect" [required] placeholder="-- Select --" inputId="bayType" class="form-control"
              name="bayType" [editable]="false" formControlName="bayType" appendTo="body">
          </p-dropdown>
          <error-block [field]="componentInventoryForm.controls.bayType" [messages]="{
            required: 'Repair Type is required.'
          }"></error-block>
        </td>
        <td>
          <p-dropdown [options]="products" [required] placeholder="-- Select Product --" inputId="productID" appendTo="body"
            class="form-control" name="product" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="productId">
          </p-dropdown>
          <error-block [field]="componentInventoryForm.controls.productId" [messages]="{
            required: 'Product is required.'
          }">
          </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="dim1x" required name="dim1x" class="form-control" formControlName="dim1x"/>
          <error-block [field]="componentInventoryForm.controls.dim1x" [messages]="{
            required: 'Skids is required.'
          }">
          </error-block>
        </td>
        <td></td>
        <td>
          <input type="number" lib-numeric pInputText id="dim1y" required name="dim1y" class="form-control" formControlName="dim1y"/>
          <error-block [field]="componentInventoryForm.controls.dim1y" [messages]="{
            required: 'Quantity is required.'
          }">
          </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="pieces1" required name="pieces1" class="form-control" formControlName="pieces1"/>
          <error-block [field]="componentInventoryForm.controls.pieces1" [messages]="{
            required: 'pieces is required.'
          }">
          </error-block>
        </td>
        <td class="centered">
          {{formTotalInventory}}
        </td>
        <td *ngIf="isChepComponents">
          <input type="number" lib-numeric pInputText id="allocatedFromPlus" required name="allocatedFromPlus" class="form-control" formControlName="allocatedFromPlus" />
          <error-block [field]="componentInventoryForm.controls.allocatedFromPlus" [messages]="{
            required: 'Allocated From Plus is required.'
          }">
          </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="reclaimedFromTdwn" required name="reclaimedFromTdwn" class="form-control" formControlName="reclaimedFromTdwn"/>
          <error-block [field]="componentInventoryForm.controls.reclaimedFromTdwn" [messages]="{
            required: 'Teardown Reclaimed is required.'
          }">
          </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="reclaimedFromSort" required name="reclaimedFromSort" class="form-control" formControlName="reclaimedFromSort"/>
          <error-block [field]="componentInventoryForm.controls.reclaimedFromSort" [messages]="{
            required: 'Sorters Reclaimed is required.'
          }">
          </error-block>
        </td>
        <td>
          <button type="button" pButton
            icon="pi pi-plus"
            iconPos="left"
            (click)="saveCI();"
            label="Add"
            [disabled]="componentInventoryForm.disabled"
            [ngClass]="{ 'p-state-disabled': !componentInventoryForm.valid }"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
